import script from "./MailchimpBase.vue?vue&type=script&lang=js"
export * from "./MailchimpBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-413e0db5"]])

export default __exports__